
    import {
        computed, defineComponent, unref, ref, watch,
    } from 'vue';
    import { useState } from 'vuex-composition-helpers';
    import { MapForFiltersState } from '@ve/components/hotel/filters/common/store/types';
    import {
        IReturnProductType, IReturnProductHotelOffer, IReturnProductRailways, IReturnProductTour,
    } from '@ve/pages/hotel/types';
    import TourUrlAdapter from '@ve/pages/hotel/adapters/TourUrlAdapter';
    import groupByRoomDate from './services/groupByRoomDate';
    import ButtonPagination from '../hotelButtons/ButtonPagination.vue';
    import usePaginationHotelCard from './use/usePaginationHotelCard';
    import { IRoomCategories } from './types';
    import HotelCard from './HotelCard.vue';

    export default defineComponent({
        components: {
            HotelCard,
            ButtonPagination,
        },
        setup(props, { emit }) {
            const { filteredTourProductsByDates, loadingState, directFlight } = useState<MapForFiltersState>('mapForFilters', ['filteredTourProductsByDates', 'loadingState', 'directFlight']);
            const groupedProducts = computed(() => {
                const productsSimilar = unref(filteredTourProductsByDates);
                return groupByRoomDate(productsSimilar);
            });
            const takenRoomCategories = ref<IRoomCategories[]>([]);

            const deleteRoomCategory = (criteriaRoom: string) => {
                takenRoomCategories.value = unref(takenRoomCategories).filter((roomCategory) => roomCategory.criteriaRoom !== criteriaRoom);
            };

            const addRoomCategory = (criteriaRoom: string, productType: IReturnProductType['type']) => {
                unref(takenRoomCategories).push({ criteriaRoom, productType });
            };

            const updateRoomCategory = (criteriaRoom: string, productType: IReturnProductType['type']) => {
                deleteRoomCategory(criteriaRoom);
                addRoomCategory(criteriaRoom, productType);
            };

            const clickAdditionalProductHandler = (products: IReturnProductHotelOffer[] | IReturnProductRailways[] | IReturnProductTour[]) => {
                const firstProduct = products[0];
                if (firstProduct.type === 'TourProduct') {
                    const tourProducts: IReturnProductTour[] = products as IReturnProductTour[];
                    const { url } = TourUrlAdapter(tourProducts, unref(directFlight));
                    window.location.href = url;
                }
                if (firstProduct.type === 'HotelOfferProduct') {
                    emit('hotelOffersProductsClick', products);
                }
                if (firstProduct.type === 'RailwayTourProduct') {
                    emit('railWaysProductsClick', products);
                }
            };

            const {
                paginationText,
                isNextProductsExists,
                paginationGroupedProducts,
                updateNumberCard,
                resetNumberCard,
            } = usePaginationHotelCard(groupedProducts, 5, 'типов комнат;типов комнат;типов комнат');

            watch(loadingState, (value) => {
                if (value === 'loading') {
                    resetNumberCard();
                    takenRoomCategories.value = [];
                }
            });

            return {
                groupedProducts,
                updateRoomCategory,
                addRoomCategory,
                deleteRoomCategory,
                takenRoomCategories,
                clickAdditionalProductHandler,
                paginationText,
                isNextProductsExists,
                paginationGroupedProducts,
                updateNumberCard,
                resetNumberCard,
            };
        },
    });
